import React from "react";
import { gql, graphql } from "react-apollo";

const LOGGED_IN_USER = gql`
  query LoggedInUser {
    loggedInUser {
      id
    }
  }
`;

const withLoggedUser = WrappedComponent => {
  return graphql(LOGGED_IN_USER, {
    name: "loggedUserQuery",
    options: { fetchPolicy: "network-only" }
  })(
    class LoggedUser extends React.Component {
      render() {
        if(this.props.loggedUserQuery.loading){
            return <div>loading..</div>
        }
        return <WrappedComponent {...this.props}/>;
      }
    }
  );
};

export default withLoggedUser;



// WEBPACK FOOTER //
// ./src/templates/authenticate/withLoggedUser.js